import { toPathOptions } from '../utils/treeUtil';
import { toPathKey, getAllChildValue } from '../utils/commonUtil';
import { computed } from 'vue';
import { isValidElement } from '../../_util/props-util';
import { cloneElement } from '../../_util/vnode';
export default (filterRepeatDisplay, rawValues, options, fieldNames, multiple, displayRender) => {
    return computed(() => {
        const mergedDisplayRender = displayRender.value ||
            // Default displayRender
            (({ labels }) => {
                const mergedLabels = multiple.value ? labels.slice(-1) : labels;
                const SPLIT = ' / ';
                if (mergedLabels.every(label => ['string', 'number'].includes(typeof label))) {
                    return mergedLabels.join(SPLIT);
                }
                // If exist non-string value, use VueNode instead
                return mergedLabels.reduce((list, label, index) => {
                    const keyedLabel = isValidElement(label)
                        ? cloneElement(label, { key: index })
                        : label;
                    if (index === 0) {
                        return [keyedLabel];
                    }
                    return [...list, SPLIT, keyedLabel];
                }, []);
            });
        const valueShowMap = {}; // 是否展示的map对象，去重
        let flatParentData = []; // 存储所有父级的铺平子数据
        const result = rawValues.value.map(valueCells => {
            const valueOptions = toPathOptions(valueCells, options.value, fieldNames.value);
            const label = mergedDisplayRender({
                labels: valueOptions.map(({ option, value }) => option?.[fieldNames.value.label] ?? value),
                selectedOptions: valueOptions.map(({ option }) => option),
            });
            const value = toPathKey(valueCells);
            const triggerOption = valueOptions[valueOptions.length - 1].option;
            if (triggerOption?.children?.length) {
                flatParentData = flatParentData.concat(getAllChildValue(triggerOption.children));
            }
            return {
                label,
                value,
                key: value,
                valueCells,
                option: triggerOption,
            };
        });
        if (!filterRepeatDisplay)
            return result;
        const filterResult = result.flatMap(item => {
            const lastValue = item.valueCells[item.valueCells.length - 1];
            if (item.option.children?.length) {
                // 所选是父级，不用过滤展示
                return [item];
            }
            if (flatParentData.some(child => {
                return child === lastValue;
            })) {
                // 对应节点中父已包含子，隐藏
                return [];
            }
            if (!valueShowMap[lastValue]) {
                valueShowMap[lastValue] = true;
                return [item];
            }
            else {
                // 对应节点中有重复子节点，隐藏
                return [];
            }
        });
        return filterResult;
    });
};
